import Vue from 'vue';

import FormActions from './FormActions';

Vue.component('ui-form-actions', FormActions);



// WEBPACK FOOTER //
// ./src/components/index.js